import WorkspaceService from "@core-ui/ContextServices/Workspace";
import { usePlatform } from "@core-ui/hooks/usePlatform";
import PermissionService from "@ext/security/logic/Permission/components/PermissionService";
import { editWorkspaceToolsPermission } from "@ext/security/logic/Permission/Permissions";
import { useEnabledToolsState } from "./useWorkspaceToolsStore";

// Mirrors the command: a read-only app reloads on its server, for editors only. Not the page's `isReadOnly`: web
// and desktop reload anyone's own copy, in a catalog they only read too.
export const reloadsFor = (isReadOnlyApp: boolean, canEditTools: boolean): boolean => !isReadOnlyApp || canEditTools;

export const useCanReload = (): boolean => {
	const { isNext } = usePlatform();
	const workspacePath = WorkspaceService.current()?.path;
	const toolsCatalog = useEnabledToolsState()?.catalogName;
	const canEdit = PermissionService.useCheckPermission(editWorkspaceToolsPermission, workspacePath);
	return reloadsFor(isNext, !!toolsCatalog && canEdit);
};
